import io from 'socket.io-client';
import { rootPath } from '@/common/utils/pathPrefix.util';

const socket = io({
  path: `${rootPath}/ws`,
  autoConnect: false,
});

export default socket;
